/* eslint-disable prettier/prettier */
import React, { useCallback } from 'react';
import Image from './Image';
import { useSelector } from 'react-redux';

/**
 * @param props.key
 * @param props.title
 * @param props.isSelected
 * @param props.imageFileName
 * @param props.colorFileName
 * @param props.handleClick
 * @param props.imageAlt
 * @param props.config
 * @param props.className
 */
const ColorButton = props => {
    const opacity = useSelector(state => state.slider);
    const baseURLs = useSelector(state => state.main.baseURLs);
    const isLearnMoreModalOpen = useSelector(state => state.main.isLearnMoreModalOpen);

    const handleTabFocus = useCallback(event => {
        const sliderElement = document.querySelector('.lens-slider');

        if (event.key === 'Enter') {
            setTimeout(() => sliderElement?.focus(), 0);
        }
        return;
    }, []);

    return (
        <button
            className={
                'color-button cursor-hand' +
                (props.isSelected && props.config.brand !== 'glasses'
                    ? ' color-button-selected'
                    : '') +
                props.className
            }
            onClick={props.handleClick}
            tabIndex={isLearnMoreModalOpen ? '-1' : '0'}
            onKeyPress={handleTabFocus}
        >
            <div className={'color-container' + (props.isSelected ? ' color-button-selected' : '')}>
                <div className="color-image">
                    <Image
                        imageClass="lens-image slider-image"
                        url={baseURLs.projectImage}
                        fileName={props.imageFileName}
                        alt={props.imageAlt}
                    />
                    <Image
                        imageClass="color-image-upper slider-image"
                        url={baseURLs.projectImage}
                        fileName={props.colorFileName}
                        style={opacity}
                        alt={`${props.imageAlt} lens`}
                    />
                </div>
                <div className="color-element">
                    <div
                        className={
                            'color-title' + (props.isSelected ? ' color-title-selected' : '')
                        }
                    >
                        {props.title}
                    </div>
                </div>
            </div>
        </button>
    );
};

export default ColorButton;
